<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-info">
          <div>
            <img alt="full_screen_required" src="../assets/full_screen.svg" />
          </div>
          <div class="modal-text">
            <h4>Do not escape full screen while test is running</h4>
            <span
              >You are required to take the test in full screen mode. Do not
              refresh the test, else test will end.</span
            >
          </div>
        </div>
        <div class="modal-footer">
          <button class="go-back-button" @click="goFullScreen">
            GO FULLSCREEN
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FullScreen',
  methods: {
    goFullScreen() {
      this.launchIntoFullscreen(document.documentElement)
      this.$emit('close')
    },
    launchIntoFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    },
  },
}
</script>

<style scoped>
.go-back {
  margin-top: 20px;
  text-align: center;
}
.go-back-button {
  border: 1px solid #0988f4;
  border-radius: 2px;
  height: 40px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: white;
  background-color: #0988f4;
  cursor: pointer;
  outline: #0988f4;
  padding: 10px 16px;
}
.modal-mask {
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: rgba(0,0,0,0.4); */
  background: #374868;
  display: table;
  transition: opacity 0.3s ease;
  margin-top: 64px;
}
.modal-wrapper {
  margin-top: 88px;
}
.modal-container {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  box-shadow: 0 3px 0 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 500px;
  margin: auto;
  display: flex;
  flex-direction: column;
}
.modal-info {
  display: flex;
  padding: 32px;
}
.modal-text {
  margin-left: 48px;
}
.modal-text h4 {
  font-family: 'Roboto-Light';
  font-size: 24px;
  color: #616262;
  letter-spacing: 0;
}
.modal-text span {
  display: block;
  margin-top: 10px;
  font-family: 'Roboto-Regular';
  font-size: 14px;
  color: #616262;
  letter-spacing: 0;
}
.modal-footer {
  border-top: 1px solid #d9d9d9;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
